import { enableProdMode } from '@angular/core';

import { KeycloakService } from './app/authentication/keycloak.service';
import { isProduction } from './environments/environment.service';
import { AppComponent } from './app/app.component';
import { bootstrapApplication } from '@angular/platform-browser';
import { appConfig } from './app/app.config';

if (isProduction) {
  enableProdMode();
}

KeycloakService.init()
  .then(() => {
    bootstrapApplication(
      AppComponent, appConfig)
      .catch(err => console.log(err));
  });
